import React, {useEffect, useState} from "react";
import Button from "../ui-components/Button";
import blocksSettings from "./blocksSettings";
import ServiceConfiguratorActionsBox from "./ServiceConfiguratorActionsBox";
import {CheckCircleIcon, CurrencyEuroIcon, EyeSlashIcon} from "@heroicons/react/24/outline";
import MoveBlock from "./MoveBlock";
import Input from "../ui-components/Input";
import {getSeparator} from "./ServiceConfiguratorSeparator";

const addButtons = [
  {
    type: "question",
    text: "ADD QUESTION",
    styleType: "blue",
    className: "mr-4",
  },
  {type: "alert", text: "ADD ALERT", className: "mr-4", styleType: "pink"},
  {
    type: "output",
    text: "ADD OUTPUT",
    className: "mr-4",
    styleType: "gray",
  },
  {
    type: "recursive_question",
    text: "RECURSIVE QUESTION",
    styleType: "greenBlack",
  },
];

const ServiceConfiguratorBlock = ({
  block,
  blockType,
  setOpenBlock,
  createAndFetchNewElement,
  list,
  openBlock,
  data,
  moveBlock,
  position,
  listLength,
  selectBlock,
  unselectBlock,
  selectedIds,
  pasteBlocks,
  openBlockServiceBlock,
  setOpenBlockServiceBlock,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const [newIndex, setNewIndex] = useState((list || []).length);
  const [isSelectButtonVisible, setSelectButtonVisible] = useState(false);
  const isSelected = selectedIds.indexOf(block.id) >= 0;

  const isFromDifferentService = block.service_id !== rest.service.id;

  useEffect(() => {
    setNewIndex((list || []).length)
  }, [setNewIndex, list])

  const isStepOrRecursive =
    blockType === "step" || blockType === "recursive_question";

  const isService = blockType === "service";

  const title = block.name
    ? block.name
    : block.output_type !== 'separator'
      ? blockType
      : getSeparator(block.output_input_id);

  const currentBlockCrossData = rest.crossData?.find(d => d.block_id === block.id);

  const showActive = isFromDifferentService && ![null,undefined].includes(currentBlockCrossData?.active) ? currentBlockCrossData.active : block.active;
  const blockFlgOutputVisibility = isFromDifferentService
  && ![null, undefined].includes(currentBlockCrossData?.flg_output_visibility) ? currentBlockCrossData.flg_output_visibility : block.flg_output_visibility;
  return (
    <div
      // onClick={(e) => {
      //   e.stopPropagation();
      //
      //   if (openBlock) {
      //     return;
      //   }
      //   if (isStepOrRecursive) {
      //     setOpen(!open);
      //     return;
      //   }
      //   setOpenBlock(block.id);
      // }}
      className={`${blocksSettings[blockType].color} ${
        blocksSettings[blockType]?.border || ""
      }  cursor-pointer mb-4   overflow-hidden  flex flex-col w-full`}
    >
      <div
        onMouseEnter={() => {
          setSelectButtonVisible(true);
        }}
        onMouseLeave={() => setSelectButtonVisible(false)}
        className="flex w-full px-4 py-2 justify-between items-center gap-4"
      >
        <div className="flex items-center gap-2" style={{maxWidth: "75%"}}>
          {!isFromDifferentService && <MoveBlock
            moveBlock={moveBlock}
            block={block}
            position={position}
            listLength={listLength}
          />}
          <h2
            onClick={(e) => {
              e.stopPropagation();
              if (openBlock) {
                return;
              }
              setOpenBlockServiceBlock(data.find(d => d.id === rest.serviceBlockId));
              setOpenBlock(block.id);
            }}
            className="mr-2 cursor-pointer text-xl font-bold text-black-500 sm:text-2xl capitalize truncate"
            title={title}
          >
            {title}
          </h2>
          {showActive && (
            <CheckCircleIcon
              className={`h-6 w-6 flex-shrink-0 ${blockType === "step" ? "text-green-400" : "text-black"}`}
            />
          )}
          {block.type === "output" && <>
            {blockFlgOutputVisibility !== 3 && (
              <div
                className="border-am-700 py-1 px-1.5 flex flex-row gap-1 items-center font-medium text-xxs"
                style={{borderWidth: "1.5px"}}
              >
                <EyeSlashIcon className="h-4 w-4" />
                {[["WEB", 0x1], ["PDF", 0x2]]
                  .filter(([_, flag]) => ((block.flg_output_visibility || 0) & flag) === 0)
                  .map(([label], idx, arr) => <React.Fragment key={idx}>
                    <span>{label}</span>
                    {idx < arr.length - 1 && <span>/</span>}
                  </React.Fragment>)}
              </div>
            )}
            {!!block.output_currency && block.flg_subtotal && (
              <CurrencyEuroIcon
                title="Subtotal"
                className={`w-6 h-6 rounded-full ${blocksSettings[blockType].color}`}
              />
            )}
          </>}
          {(!isStepOrRecursive || selectedIds.length) && !isService && !isFromDifferentService ? (
            <Button
              className="ml-4"
              styleType={
                isStepOrRecursive
                  ? "greenWhite"
                  : isSelected
                    ? "empty"
                    : "default"
              }
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                if (!isStepOrRecursive) {
                  if (isSelected) {
                    unselectBlock(block);
                    return;
                  }
                  selectBlock(block);
                  return;
                } else {
                  pasteBlocks(block);
                }
              }}
              style={{opacity: isSelectButtonVisible ? 1 : 0}}
            >
              {!isStepOrRecursive
                ? isSelected
                  ? "UNSELECT"
                  : "SELECT"
                : "PASTE"}
            </Button>
          ) : null}
        </div>
        <ServiceConfiguratorActionsBox
          open={open}
          setOpen={setOpen}
          blockType={blockType}
          hidden={block.hidden_question}
          {...rest}
        />
      </div>

      {open && (isStepOrRecursive || isService)? (
        <div className="flex w-full flex-col pt-8 border-t border-black px-4">
          <div className="w-full flex justify-between">
            <div className="w-full flex">
            {!isService && !isFromDifferentService && addButtons
              .filter((b) =>
                blockType === "recursive_question"
                  ? b.type !== "recursive_question"
                  : true
              )
              .map(({type, styleType, className, text}) => (
                <Button
                  key={type}
                  className={className}
                  styleType={styleType}
                  onClick={(e) => {
                    e.stopPropagation();
                    createAndFetchNewElement({
                      type,
                      order: (newIndex || newIndex === 0) ? newIndex : list.length,
                      ...(blockType === "recursive_question"
                        ? {recursive_question_id: block.id}
                        : {step_id: block.id}),
                    });
                  }}
                >
                  {text}
                </Button>
              ))}
            </div>
            {!isFromDifferentService || block.type === 'service'
              && <div className="flex flex-row ml-3 gap-1 -mt-1 justify-center">
              <div className="mt-3 whitespace-nowrap">
                At index
              </div>
              <div className="w-16">
                <Input
                  type="number"
                  value={newIndex}
                  onChange={(e) => setNewIndex(e.target.value)}
                />
              </div>
            </div>}
          </div>
          {isStepOrRecursive ?
            <div className="flex flex-col w-full mt-8">
              {list.map((b, index, self) => (
                <ServiceConfiguratorBlock
                  position={index}
                  listLength={self.length}
                  moveBlock={moveBlock}
                  key={b.id}
                  block={b}
                  blockType={b.type}
                  setOpenBlock={setOpenBlock}
                  openBlock={openBlock}
                  createAndFetchNewElement={createAndFetchNewElement}
                  selectBlock={selectBlock}
                  unselectBlock={unselectBlock}
                  selectedIds={selectedIds}
                  pasteBlocks={pasteBlocks}
                  data={data}
                  list={
                    b.type === "recursive_question"
                      ? data.filter((row) => row.recursive_question_id === b.id)
                      : undefined
                  }
                  openBlockServiceBlock={openBlockServiceBlock}
                  setOpenBlockServiceBlock={setOpenBlockServiceBlock}
                  {...rest}
                />
              ))}
            </div> :
            <div className={"flex flex-col w-full mt-4"}>
              {list.map((s, index, self) => {
                  return <ServiceConfiguratorBlock
                    key={s.id}
                    position={index}
                    listLength={self.length}
                    block={s}
                    blockType={s.type}
                    list={data.filter((row) => row.step_id === s.id)}
                    data={data}
                    selectedIds={selectedIds}
                    moveBlock={moveBlock}
                    setOpenBlock={setOpenBlock}
                    createAndFetchNewElement={createAndFetchNewElement}
                    selectBlock={selectBlock}
                    unselectBlock={unselectBlock}
                    pasteBlocks={pasteBlocks}
                    openBlockServiceBlock={openBlockServiceBlock}
                    setOpenBlockServiceBlock={setOpenBlockServiceBlock}
                    {...rest}
                  />
                }
              )}
            </div>}
        </div>
      ) : null}
    </div>
  );
};

export default ServiceConfiguratorBlock;
